export const translations = {
  en: {
    greeting: {
      title: "Solutions & Integration Architect",
      subtitle: "19 years building enterprise software. I lead a team of 8 at a French agribusiness multinational — SAP B1 deep integrations, agentic AI systems with Claude and MCP, and ISO 27001 / LGPD programs as DPO.",
      availability: "Open for: Integration architecture · SAP B1 · Applied AI roles · Remote · USD/EUR · PJ or full-time · Available",
      contactMe: "Contact me",
      seeMyResume: "See my resume"
    },
    skills: {
      title: "Tech Stack",
      subtitle: "What I do",
      alsoWorking: "Also working with: Next.js · Kubernetes · Kafka · RabbitMQ · Keycloak/SSO · Qlik Sense · n8n · Claude API & MCP · Node.js · Traefik.",
      skills: [
        "🧑‍💼 Leading engineering teams on internal enterprise systems",
        "🔌 Architecting SAP B1 integrations via REST, SOAP, and Service Layer",
        "🤖 Building agentic AI systems with Claude, MCP servers, and FastAPI",
        "🔒 Running ISO 27001 and GDPR-equivalent (Brazilian LGPD) compliance programs"
      ]
    },
    areasOfImpact: {
      title: "Areas of Impact",
      columns: [
        {
          heading: "Architecture & Backend",
          items: "SAP B1 integrations · FastAPI · Python · Node.js · PostgreSQL · REST / SOAP APIs · Microservices"
        },
        {
          heading: "AI & Automation",
          items: "Agentic AI · Claude API & MCP servers · RAG / pgvector · n8n workflows · WhatsApp & email automation"
        },
        {
          heading: "Leadership & Compliance",
          items: "Team of 8 · ISO 27001 program · GDPR-equivalent (Brazilian LGPD) · appointed DPO · SIEM · MFA · Keycloak SSO"
        }
      ]
    },
    projects: {
      title: "Projects",
      subtitle: "Some Projects Developed By Me",
      moreProjects: "More projects on GitHub →"
    },
    education: {
      title: "Education",
      subtitle: "My Academic Background"
    },
    experience: {
      title: "Experience",
      subtitle: "Work Experience"
    },
    contact: {
      title: "Contact ☎️",
      subtitle: "Open to integration architecture, SAP B1, and applied AI roles — remote, PJ or full-time. Happy to discuss enterprise integration, agentic AI, SAP B1, or compliance programs."
    },
    footer: {
      madeWith: "Made with ❤️ by Mateus Furrier",
      
    }
  },
  pt: {
    greeting: {
      title: "Arquiteto de Soluções e Integração",
      subtitle: "19 anos construindo software corporativo. Lidero um time de 8 em uma multinacional francesa do agronegócio — integrações profundas com SAP B1, sistemas de IA agêntica com Claude e MCP, e programas ISO 27001 / LGPD como DPO.",
      availability: "Aberto a: Arquitetura de integração · SAP B1 · Vagas de IA aplicada · Remoto · USD/EUR · PJ ou CLT · Disponível",
      contactMe: "Entre em contato",
      seeMyResume: "Veja meu currículo"
    },
    skills: {
      title: "Tech Stack",
      subtitle: "O que eu faço",
      alsoWorking: "Também trabalho com: Next.js · Kubernetes · Kafka · RabbitMQ · Keycloak/SSO · Qlik Sense · n8n · Claude API & MCP · Node.js · Traefik.",
      skills: [
        "🧑‍💼 Liderando times de engenharia em sistemas corporativos internos",
        "🔌 Arquitetando integrações SAP B1 via REST, SOAP e Service Layer",
        "🤖 Construindo sistemas de IA agêntica com Claude, servidores MCP e FastAPI",
        "🔒 Conduzindo programas de compliance ISO 27001 e LGPD"
      ]
    },
    areasOfImpact: {
      title: "Áreas de Atuação",
      columns: [
        {
          heading: "Arquitetura & Backend",
          items: "Integrações SAP B1 · FastAPI · Python · Node.js · PostgreSQL · APIs REST / SOAP · Microsserviços"
        },
        {
          heading: "IA & Automação",
          items: "IA agêntica · Claude API & servidores MCP · RAG / pgvector · Workflows n8n · Automação de WhatsApp e e-mail"
        },
        {
          heading: "Liderança & Compliance",
          items: "Time de 8 · Programa ISO 27001 · LGPD · DPO designado · SIEM · MFA · Keycloak SSO"
        }
      ]
    },
    projects: {
      title: "Projetos",
      subtitle: "Alguns Projetos Desenvolvidos Por Mim",
      moreProjects: "Mais projetos no GitHub →"
    },
    education: {
      title: "Educação",
      subtitle: "Minha Formação Acadêmica"
    },
    experience: {
      title: "Experiência",
      subtitle: "Experiência Profissional"
    },
    contact: {
      title: "Contato ☎️",
      subtitle: "Aberto a vagas de arquitetura de integração, SAP B1 e IA aplicada — remoto, PJ ou CLT. Disponível para conversar sobre integração corporativa, IA agêntica, SAP B1, ou programas de compliance."
    },
    footer: {
      madeWith: "Feito com ❤️ por Mateus Furrier",
      
    }
  }
}; 